module.exports = __webpack_public_path__ + "media/62.0cc6f47e.wav";